const javascriptExpressionOperandType = {
    NUMBER : 'Number',

    ANY : 'Any',

    NOT_APPLICABLE : 'N/A'

};

angular.module('gw-um-j2js')
    .constant('javascriptExpressionOperandType', javascriptExpressionOperandType);